import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import { Observable } from 'rxjs';

import { Amount } from '@fcom/dapi';
import { FinnairOrder } from '@fcom/dapi/api/models/finnair-order';
import { FinnairTotalPricesDetails } from '@fcom/dapi/api/models/finnair-total-prices-details';

@Component({
  selector: 'fin-price-summary',
  templateUrl: './price-summary.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PriceSummary {
  @Input()
  order$: Observable<FinnairOrder>;

  @Input()
  breakdownTotalPrice$: Observable<Amount>;

  @Input()
  breakdownTotalKey$: Observable<string>;

  @Input()
  prices$: Observable<FinnairTotalPricesDetails>;

  readonly helperText = input<string | null>(null);
}
